module.exports = __webpack_public_path__ + "img/donante-comision-dh-baja-california.a1c53f7b.png";